import { type ObjectValuesUnionType } from '../../../utils/typing';

import { type GRChipStatus } from './chip';
import { type GRRound } from './round';

export const GRNotificationTypes = Object.freeze({
  BETSLIP_UPDATE: 'BETSLIP_UPDATE',
  ROUND_COMPLETE: 'ROUND_COMPLETE',
  ROUND_FAILED: 'ROUND_FAILED',
});

export type GRNotificationType = ObjectValuesUnionType<typeof GRNotificationTypes>;

export type GRNotificationState = {
  uuid: string;
  type: GRNotificationType;
  data: {
    betslipReference?: string | null;

    previousStatus?: GRChipStatus | null;
    nextStatus?: GRChipStatus | null;

    previousRound?: GRRound | null;
    nextRound?: GRRound | null;

    previousPoints?: number | null;
    nextPoints?: number | null;

    baseAmount?: number | null;
    bonusCoefficient?: number | null;
    totalAmount?: number | null;
  };
};

export const GRFullScreenNotifications = Object.freeze({
  [GRNotificationTypes.ROUND_COMPLETE]: GRNotificationTypes.ROUND_COMPLETE,
  [GRNotificationTypes.ROUND_FAILED]: GRNotificationTypes.ROUND_FAILED,
});

export type GRFullScreenNotification = ObjectValuesUnionType<typeof GRFullScreenNotifications>;
